<template>
    <AuthLayout>
        <FullscreenLoading v-if="isDeleteLoading || isUpdateLoading || isUpdatePasswordLoading" />

        <div class="container">
            <div class="card p-4" v-if="hasPermission('updateAccount')">
                <div class="row mb-3">
                    <div class="col-12">
                        <AccountForm
                            @submit="updateAccount"
                            :errors="updateAccountErrors"
                            :is-loading="isUpdateLoading"
                            :default-values="user"
                        />
                    </div>
                </div>
            </div>

            <div class="card p-4" v-if="hasPermission('updatePassword')">
                <div class="row mb-3">
                    <div class="col-12">
                        <UpdatePasswordForm
                            @loading="isUpdatePasswordLoading = $event"
                        />
                    </div>
                </div>
            </div>

            <div class="card p-4" v-if="hasPermission('deleteAccount')">
                <div class="row mb-3">
                    <div class="col-12">
                        <DeleteAccountForm
                            @loading="isDeleteLoading = $event"
                            @deleted="deleted"
                        />
                    </div>
                </div>
            </div>
        </div>
    </AuthLayout>
</template>
<script>

    import { mapGetters, mapState } from 'vuex';
    import { IpcCall, ipcCall } from '../utils/ipcCall';
    import AuthLayout from './AuthLayout.vue';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import i18n from '../../utils/locale';
    import DeleteAccountForm from '../../forms/DeleteAccountForm.vue';
    import { AccountService } from '../../services/accountService';
    import AccountForm from '../../forms/AccountForm.vue';
    import { notifyError, notifySuccess } from '../../utils/notify';
    import UpdatePasswordForm from '../../forms/UpdatePasswordForm.vue';

    export default {
        components: {
            UpdatePasswordForm,
            AccountForm,
            DeleteAccountForm,
            AuthLayout,
            FullscreenLoading,
        },

        computed: {
            ...mapState({
                user: state => state.user,
            }),
            ...mapGetters(['hasPermission']),
        },

        data() {
            return {
                isDeleteLoading: false,
                isUpdateLoading: false,
                isUpdatePasswordLoading: false,

                updateAccountErrors: null,
            };
        },

        methods: {
            async updateAccount(data) {
                this.isUpdateLoading = true;
                this.updateAccountErrors = null;

                try {
                    const response = await AccountService.getInstance().updateAccount(data);

                    await this.$store.dispatch('updateUser', {
                        user: response.data,
                    });

                    notifySuccess(i18n.t('account.wijziging_opgeslagen'));
                } catch (exception) {
                    this.updateAccountErrors = exception?.response?.data?.errors || null;
                    notifyError(exception);
                } finally {
                    this.isUpdateLoading = false;
                }
            },

            async deleted() {
                await this.$store.dispatch('logout');
                await this.$router.push('/login?deleted_account');
                await ipcCall(IpcCall.Logout);
            },
        },
    };

</script>
